import { axiosWithJWT } from '@/api/axiosWithJWT';

export const create = async (_, transaction) => {
  const { data } = await axiosWithJWT.post(
    '/api/TaxiTransaction/Create',
    transaction
  );
  return data;
};

export const getTransactionsByTaxi = async ({ commit }, { taxiId, params }) => {
  const { data } = await axiosWithJWT.get(
    `/api/TaxiTransaction/GetListByTaxi/${taxiId}`,
    { params }
  );

  commit('storeLastTransactions', data.transactions);

  return data;
};

export const getTransactionTypes = async () => {
  const { data } = await axiosWithJWT.get('/api/TransactionType/GetList');
  return data;
};

export const getTransactionStatus = async () => {
  const { data } = await axiosWithJWT.get('/api/TransactionStatus/GetList');
  return data;
};

export const getTransactions = async (_, { params }) => {
  const { data } = await axiosWithJWT.get('/api/TaxiTransaction/GetList', {
    params,
  });
  return data;
};

export const updateTransaction = async (_, transaction) => {
  await axiosWithJWT.put(
    `/api/TaxiTransaction/Update/${transaction.id}`,
    transaction
  );
};

export const cancelTransaction = async (_, {transactionId, description}) => {
  await axiosWithJWT.put(
    `/api/TaxiTransaction/CancelTransaction/${transactionId}`,
    { description }
  );
};
